import { textEllipsis } from '../../style';
const genEllipsisStyle = token => {
  const {
    componentCls
  } = token;
  return {
    ["".concat(componentCls, "-wrapper")]: {
      ["".concat(componentCls, "-cell-ellipsis")]: Object.assign(Object.assign({}, textEllipsis), {
        wordBreak: 'keep-all',
        // Fixed first or last should special process
        ["\n          &".concat(componentCls, "-cell-fix-left-last,\n          &").concat(componentCls, "-cell-fix-right-first\n        ")]: {
          overflow: 'visible',
          ["".concat(componentCls, "-cell-content")]: {
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
          }
        },
        ["".concat(componentCls, "-column-title")]: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordBreak: 'keep-all'
        }
      })
    }
  };
};
export default genEllipsisStyle;